const Navbar = () => {
	return (
		<div
			className=" 
    w-[100%]  bg-DDarkBlue
    flex justify-between
    items-center px-5 
    shadow-2xl
    "
		>
			<div
				className="font-roboto
        font-[600]
        text-[25px]
        text-white
        
        my-4
        "
			>
				Where in the world?
			</div>
		</div>
	);
};

export default Navbar;
